export const localeCodes = ["en-GB","de-DE"]

export const localeMessages = {
  "en-GB": [{ key: "../i18n/src/langs/en-GB.ts", load: () => import("../i18n/src/langs/en-GB.ts?hash=ce317232&locale=en-GB" /* webpackChunkName: "lang_i18n_i18n_src_langs_en_GB_ts" */) }],
  "de-DE": [{ key: "../i18n/src/langs/de-DE.ts", load: () => import("../i18n/src/langs/de-DE.ts?hash=c9058571&locale=de-DE" /* webpackChunkName: "lang_i18n_i18n_src_langs_de_DE_ts" */) }],
}

export const resolveNuxtI18nOptions = async (context) => {
  const nuxtI18nOptions = Object({})
  nuxtI18nOptions.experimental = Object({"jsTsFormatResource":true,"runtimeOnly":true})
  nuxtI18nOptions.bundle = Object({"compositionOnly":true,"runtimeOnly":false,"fullInstall":true,"dropMessageCompiler":false})
  nuxtI18nOptions.compilation = Object({"jit":false,"strictMessage":false,"escapeHtml":false})
  nuxtI18nOptions.customBlocks = Object({"defaultSFCLang":"json","globalSFCScope":false})
 const vueI18nConfigLoader = async (loader) => {
            const config = await loader().then(r => r.default || r)
            return typeof config === 'object'
              ? config
              : typeof config === 'function'
                ? await config()
                : {}
          }
  const vueI18n = await vueI18nConfigLoader((() => import("../i18n/config?hash=80dc4ba0&config=1" /* webpackChunkName: "__i18n_config_80dc4ba0" */)))
  nuxtI18nOptions.vueI18n = vueI18n
  nuxtI18nOptions.vueI18n.messages ??= {}
  nuxtI18nOptions.locales = [Object({"code":"en-GB","language":"en-GB","iso":"en-GB","files":["i18n/src/langs/en-GB.ts"],"hashes":["ce317232"],"types":["dynamic"]}),Object({"code":"de-DE","language":"de-DE","iso":"de-DE","localeId":"2fbb5fe2e29a4d70aa5854ce7ce3e20b","files":["i18n/src/langs/de-DE.ts"],"hashes":["c9058571"],"types":["dynamic"]})]
  nuxtI18nOptions.defaultLocale = "de-DE"
  nuxtI18nOptions.defaultDirection = "ltr"
  nuxtI18nOptions.routesNameSeparator = "___"
  nuxtI18nOptions.trailingSlash = false
  nuxtI18nOptions.defaultLocaleRouteNameSuffix = "default"
  nuxtI18nOptions.strategy = "prefix_except_default"
  nuxtI18nOptions.lazy = true
  nuxtI18nOptions.langDir = "./i18n/src/langs/"
  nuxtI18nOptions.rootRedirect = null
  nuxtI18nOptions.detectBrowserLanguage = false
  nuxtI18nOptions.differentDomains = false
  nuxtI18nOptions.baseUrl = ""
  nuxtI18nOptions.dynamicRouteParams = false
  nuxtI18nOptions.customRoutes = "page"
  nuxtI18nOptions.pages = Object({})
  nuxtI18nOptions.skipSettingLocaleOnNavigate = true
  nuxtI18nOptions.types = "composition"
  nuxtI18nOptions.debug = false
  nuxtI18nOptions.parallelPlugin = false
  nuxtI18nOptions.fallbackLocale = "de-DE"
  nuxtI18nOptions.i18nModules = []
  return nuxtI18nOptions
}

export const nuxtI18nOptionsDefault = Object({experimental: Object({"jsTsFormatResource":false}),bundle: Object({"compositionOnly":true,"runtimeOnly":false,"fullInstall":true,"dropMessageCompiler":false}),compilation: Object({"jit":true,"strictMessage":true,"escapeHtml":false}),customBlocks: Object({"defaultSFCLang":"json","globalSFCScope":false}),vueI18n: "",locales: [],defaultLocale: "",defaultDirection: "ltr",routesNameSeparator: "___",trailingSlash: false,defaultLocaleRouteNameSuffix: "default",strategy: "prefix_except_default",lazy: false,langDir: null,rootRedirect: null,detectBrowserLanguage: Object({"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true}),differentDomains: false,baseUrl: "",dynamicRouteParams: false,customRoutes: "page",pages: Object({}),skipSettingLocaleOnNavigate: false,types: "composition",debug: false,parallelPlugin: false})

export const nuxtI18nInternalOptions = Object({__normalizedLocales: [Object({"code":"en-GB","language":"en-GB","iso":"en-GB","files":["i18n/src/langs/en-GB.ts"],"hashes":["ce317232"],"types":["dynamic"]}),Object({"code":"de-DE","language":"de-DE","iso":"de-DE","localeId":"2fbb5fe2e29a4d70aa5854ce7ce3e20b","files":["i18n/src/langs/de-DE.ts"],"hashes":["c9058571"],"types":["dynamic"]})]})
export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const isSSG = false
export const parallelPlugin = false
